'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default function () {
    return {
        restrict: 'A',
        template: require('../../../../../../../view/table.html'),
        transclude: true,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter'
        },
        controller: ['$scope', '$uibModal', 'StatusService', 'InvestorCountryService', 'Notification', '$utils', 'ModalService',
            function ($scope, $modal, StatusService, InvestorCountryService, Notification, $utils, ModalService) {

                $scope.refresh = refresh;
                $scope.dblClick = dblClick;
                $scope.select = select;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;
                $scope.getStatusDisplayName = StatusService.getDisplayName;

                init();

                // region Functions

                function init() {
                    $scope.loading = true;

                    if (!$scope.selectedItem) {
                        $scope.selectedItem = {};
                    }

                    $scope.columns = [{
                        name: "Код",
                        data: "id"
                    },{
                        name: "Наименование",
                        data: "name"
                    }, {
                        name: "Требует страну происхождения",
                        data: "specified",
                        type: "boolean"
                    }, {
                        name: "Статус",
                        data: "status",
                        type: "status"
                    }];

                    $scope.searching = {
                        isSearch: $scope.isSearch,
                        filter: null
                    };

                    $scope.pagination = {
                        isPaging: $scope.isPaging,
                        page: 1,
                        size: $scope.isPaging ? 10 : null,
                        totalPages: null,
                        totalItems: null
                    };

                    // тулбокс таблицы
                    $scope.toolbox = {
                        // кнопки на панели управления
                        buttons: {
                            // создание
                            create: {
                                show: () => true,
                                click: () => InvestorCountryService.create().result.then(function (data) {
                                    InvestorCountryService.api.create(null, {"form": data}, (data) => {
                                        $scope.selectedItem = data._embedded;
                                        $scope.refresh();
                                    });
                                }),
                                disabled: () => false,
                            },
                            // редактирование
                            edit: {
                                show: () => true,
                                click: (item) => InvestorCountryService.edit(item).result.then(function (data) {
                                    InvestorCountryService.api.update({investorCountryId: data.id}, {"form": data}, (data) => {
                                        $scope.selectedItem = data._embedded;
                                        $scope.refresh();
                                    });
                                }),
                                disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                            },
                            // активация
                            enable: {
                                show: () => isSelected() && (getSelected().status == 'DELETED'),
                                click: (item) => InvestorCountryService.api.enable({investorCountryId: item.id}, null, (data) => {
                                    $scope.selectedItem = data._embedded;
                                    $scope.refresh();
                                    Notification.success({
                                        message: 'Происхождение инвесторов восстановлено!',
                                    });
                                }),
                                disabled: () => !isSelected() || getSelected().status == 'ENABLED',
                            },
                            // блокирование
                            disable: {
                                show: () => false,
                                click: (item) => {
                                },
                                disabled: () => true,
                            },
                            // логическое удаление
                            delete: {
                                show: () => false,
                                click: (item) => InvestorCountryService.api.delete({investorCountryId: item.id}, null, (data) => $scope.refresh()),
                                disabled: () => !isSelected() || getSelected().status == 'DELETED',
                            },
                            // удаление
                            remove: {
                                show: () => isSelected() && (getSelected().status == 'ENABLED'),
                                click: (item) => ModalService.danger({
                                    message: "Запись будет удалена без возможности восстановления! Вы действительно желаете удалить данную запись?",
                                    apply: "Да",
                                    cancel: "Нет"
                                }).result.then(() => InvestorCountryService.api.remove({investorCountryId: item.id}, null, (data) => {
                                        $scope.refresh();
                                        Notification.success({
                                            message: 'Происхождение инвесторов удалено!',
                                        });
                                    },
                                    (error) => {
                                        Notification.warning({
                                            title: "Внимание!",
                                            message: 'Данную запись удалить нельзя,<br />т.к. на нее ссылаются записи других таблиц.<br />Она будет помечена как "удаленная".',
                                        });
                                        InvestorCountryService.api.delete({investorCountryId: item.id}, null, (data) => {
                                            $scope.refresh();
                                            Notification.success({
                                                message: 'Происхождение инвесторов помечено как "удаленное"!',
                                            });
                                        });
                                    }
                                )),
                                disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                            },
                            // обновление таблицы
                            refresh: {
                                show: () => true,
                                click: $scope.refresh,
                                disabled: () => false,
                            }
                        }
                    };

                    // получение данных
                    refresh();
                }

                /**
                 * Получение всех записей
                 * @returns {*}
                 */
                function getItems() {
                    return $scope.items;
                }

                /**
                 * Выбрал ли элемент!
                 * @param item проверяемый элемент
                 * @returns bool
                 */
                function isSelect(item) {
                    return equals(getSelected(), item);
                }

                /**
                 * Выбрать элемент
                 * @param item выбираемый элемент
                 */
                function select(item) {
                    if (!$scope.isSelect(item)) {
                        angular.copy(item, $scope.selectedItem);
                    } else {
                        angular.copy({}, $scope.selectedItem);
                    }
                }

                /**
                 * Двойное нажатие на запись в таблице
                 * @param item данные записи
                 */
                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table' :
                            $scope.toolbox.buttons.edit.click(item);
                            break;
                        case 'select' :
                            $scope.ok();
                            break;
                    }
                }

                /**
                 * Получение фильтров
                 * @returns {Array}
                 */
                function getFilters() {
                    let filters = [];
                    if (Array.isArray($scope.filters)) {
                        filters = filters.concat($scope.filters);
                    }
                    return filters;
                }

                /**
                 * Получение поиска
                 * @returns {Array}
                 */
                function getSearchs() {
                    let searchs = [];
                    if ($scope.isSearch)
                        if ($scope.searching.filter != null && !($scope.searching.filter.length < 1))
                            searchs.push("'name':'" + $scope.searching.filter + "'");
                    return searchs;
                }

                /**
                 * Выбрана ли запись
                 * @returns {boolean}
                 */
                function isSelected() {
                    return $scope.selectedItem != null && !angular.equals($scope.selectedItem, {});
                }

                /**
                 * Проверка элементов на равенство
                 * @param i1
                 * @param i2
                 * @returns {*}
                 */
                function equals(i1, i2) {
                    return angular.equals(i1, i2);
                }

                /**
                 * Получить выбранный элемент
                 * @returns {{}|*}
                 */
                function getSelected() {
                    return $scope.selectedItem;
                }

                /**
                 * Обновить данные таблицы
                 */
                function refresh() {
                    $scope.loading = true;
                    InvestorCountryService.api.getAll({
                        filters: getFilters(),
                        searchs: getSearchs(),
                        sorts: ['name:ASC'],
                        page: $scope.pagination.page,
                        size: $scope.pagination.size
                    }, function (data) {
                        $scope.items = data._embedded;
                        if (isSelected()) {
                            if ($scope.items.every(i => i.id != getSelected().id)) {
                                $scope.selectedItem = {};
                            } else {
                                angular.copy($scope.items.find(i => i.id == getSelected().id), $scope.selectedItem);
                            }
                        }
                        if ($scope.pagination.isPaging) {
                            $scope.pagination.totalPages = data.page.totalPages;
                            $scope.pagination.totalItems = data.page.totalElements;
                        }
                        $scope.loading = false;
                    });
                }

                // endregion

                // region Watchers

                $scope.$watch('filters', function () {
                    $scope.refresh();
                });

                // endregion

            }]
    };
}
